<div class="container mt-5">
  <div class="row d-flex justify-content-center">
    <div class="col-md-6">
      <div class="card px-5 py-5" id="form1">
        <div class="form-data" v-if="!submitted">
          <div class="forms-inputs mb-4">
            <span>Logged Out</span>
          </div>

        </div>

      </div>
    </div>
  </div>
</div>
